import { gql } from '@apollo/client'
import {
  BattleDemoLeaderboardFragment,
  BattleDemoMyLeaderboardRecordFragment
} from '@src/graphql/fragment/battleDemo'

export default gql`
  query GetBattleDemoMySoloPvELeaderboard($input: GetLeaderboardInput!) {
    getMyDungeonLeaderboard(input: $input) {
      ...LeaderboardCommon
      recordInfo {
        ...MyLeaderboardRecordCommon
        playerRecord {
          score
          rank
          planet {
            classIcon
            id
            metaKey
          }
          user {
            name
            tag
            walletAddress
          }
        }
      }
    }
  }
  ${BattleDemoLeaderboardFragment}
  ${BattleDemoMyLeaderboardRecordFragment}
`
